export default __webpack_public_path__ + "static/media/jqilogoblack.8d360425.png";